export const BLE_STACK_FWU_RECONNECT_POPUP_DELAY_MS = 25_000;
